<template>
	<div>
		<!-- 关联机构 -->
		<popup
			v-model="organization_display"
			title="关联机构"
			:confirmBtnDisplay="false"
		>
			<div v-loading="organization_loading" style="padding: 15px;">
				<div class="base_form_row" style="padding: 0;">
					<el-select class="b_inp" v-model="organization_search" filterable :clearable="true" placeholder="请选择" style="width: 200px;">
						<el-option
							v-for="v in allOrganization"
							:key="v.id"
							:label="v.name"
							:value="v.id">
						</el-option>
					</el-select>
					<el-button
						type="primary"
						style="margin-left: 15px;"
						@click="handleAddClick"
					>添加</el-button>
				</div>
				<div class="base_table" style="margin-top: 20px;">
					<el-table
						:data="organization_list"
						style="width: 100%"
					>
						<el-table-column
							prop="name"
							label="机构名称"
						>
						</el-table-column>
						<el-table-column
							label="操作"
							width="300"
						>
							<template slot-scope="scope">
								<el-button
									@click="handlePermissionClick(scope.row)"
								>权限管理</el-button>
								<el-button
									style="color: #f00;"
									@click="handleDeleteClick(scope.row)"
								>删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</popup>
		<!-- 关联机构 end -->
		
		<!-- 权限管理 -->
		<popup
			v-model="permission_display"
			title="权限管理"
			confirmBtnText="保存"
			@confirmClick="handlePermissionConfirmClick"
		>
			<div v-loading="permission_loading" style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>权限列表</span>
					<div class="b_checkbox_group">
						<el-checkbox-group v-model="permission_data">
							<el-checkbox v-for="v in allPermission" :key="v.id" :label="v.id">{{ v.name }}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="permission_tip"><i class="b_icon"></i>请至少选择一个权限</template></div>
			</div>
		</popup>
		<!-- 权限管理 end -->
	</div>
</template>

<script>
	import Api from '../../../../../api/index.js';
	import { mapState } from 'vuex';
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			uid: {
				type: String,
				default: ''
			},
			oid: {
				type: String,
				default: ''
			}
		},
		data () {
			return {
				organization_display: false,
				organization_loading: false,
				organization_search: '',
				organization_list: [],
				
				permission_display: false,
				permission_loading: false,
				permission_data: [],
				permission_tip: false
			}
		},
		computed: {
			...mapState([
				'allPermission',
				'allOrganization'
			])
		},
		mounted () {
			this.permission_organization_id = '';
			this.permission_organization_uid = '';
			this.display && (this.organization_display = true);
		},
		methods: {
			/*********************** @Events *************************/
			// 点击添加
			handleAddClick() {
				if (!this.organization_search) {
					this.$message.warning('请先选择一个机构！');
					return false;
				}
				this.addOrganization();
			},
			// 点击权限管理
			handlePermissionClick(obj) {
				this.permission_organization_id = obj.id;
				this.permission_organization_uid = obj.uid;
				this.getPermissionByOrganization();
			},
			// 删除关联机构
			handleDeleteClick(obj) {
				const that = this;
				that.$confirm(
					'此操作将删除该关联机构，是否继续?', 
					'提示', 
					{
						type: 'warning'
					}
				).then(
					() => {
						that.deleteOrganization(obj.uid);
					}
				).catch(
					() => {}
				);
			},
			// 点击权限保存
			handlePermissionConfirmClick() {
				if (!this.permission_data.length) {
					this.permission_tip = true;
					return false;
				} else {
					this.permission_tip = false;
				}
				this.updatePermission();
			},
			
			/*********************** @Function *************************/
			// 添加关联机构
			addOrganization() {
				const that = this;
				that.organization_loading = true;
				let requestData = {
					userId : that.uid,
					enterpriseId: that.organization_search
				};
				Api.addRelatedOrganization(requestData).then((res) => {
					that.organization_loading = false;
					if (res.data.success) {
						that.$message.success(res.data.message);
						that.findRelatedOrganizations();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.organization_loading = false;
					that.$message.error(e.message);
				});
			},
			// 查询用户关联机构
			findRelatedOrganizations() {
				const that = this;
				that.organization_loading = true;
				let requestData = {
					userId : that.uid,
					enterpriseId: that.oid
				};
				Api.findRelatedOrganizations(requestData).then((res) => {
					that.organization_loading = false;
					if (res.data.success) {
						let list = [];
						let res_list = res.data.data || [];
						res_list.forEach(v => {
							list.push({
								id: v.enterpriseId,
								uid: v.enterpriseUserId,
								name: v.enterpriseName
							});
						});
						that.organization_list = list;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.organization_loading = false;
					that.$message.error(e.message);
				});
			},
			// 删除关联机构
			deleteOrganization(id) {
				const that = this;
				that.organization_loading = true;
				Api.deleteRelatedOrganization(id).then((res) => {
					that.organization_loading = false;
					if (res.data.success) {
						that.$message.success(res.data.message);
						that.findRelatedOrganizations();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.organization_loading = false;
					that.$message.error(e.message);
				});
			},
			// 获取该机构下的权限
			getPermissionByOrganization() {
				const that = this;
				that.organization_loading = true;
				let requestData = {
					enterpriseId: that.permission_organization_id,
					userId: that.uid
				};
				Api.findPermissionByOrganization(requestData).then((res) => {
					that.organization_loading = false;
					if (res.data.success) {
						let list = [];
						res.data.data.forEach(v => {
							list.push(v.privilegeId);
						});
						that.permission_data = list;
						that.permission_display = true;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.organization_loading = false;
					that.$message.error(e.message);
				});
			},
			// 更新关联机构下的权限
			updatePermission() {
				const that = this;
				that.permission_loading = true;
				let requestData = {
					enterpriseId: that.permission_organization_id,
					userId: that.uid,
					privilegeIds: that.permission_data.join(',')
				};
				Api.updatePermissionByOrganization(requestData).then((res) => {
					that.permission_loading = false;
					if (res.data.success) {
						that.permission_display = false;
						that.$message.success(res.data.message);
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.permission_loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newValue) {
				this.organization_display = newValue;
			},
			organization_display(newValue) {
				this.$emit("changeDisplay", newValue);
				if (newValue) {
					this.findRelatedOrganizations();
				} else {
					this.organization_loading = false;
					this.organization_search = '';
					this.organization_list = [];
				}
			},
			permission_display(newValue) {
				if (!newValue) {
					this.permission_organization_id = '';
					this.permission_organization_uid = '';
					this.permission_loading = false;
					this.permission_data = [];
					this.permission_tip = false;
				}
			}
		}
	}
</script>

<style>
</style>
